var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "-1 -1 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4541 7.54425C15.1465 7.2421 14.6535 7.2421 14.3459 7.54425C14.0305 7.85397 14.0302 8.36203 14.3452 8.67209L17.436 11.7143H5.28571C4.85178 11.7143 4.5 12.0661 4.5 12.5C4.5 12.9339 4.85178 13.2857 5.28571 13.2857H17.436L14.3422 16.3242C14.0249 16.6359 14.0258 17.1475 14.3442 17.458C14.6531 17.7592 15.1461 17.7583 15.4538 17.456L19.7736 13.2134C20.1726 12.8215 20.1726 12.1785 19.7736 11.7866L15.4541 7.54425Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C6.14873 24 1 18.8513 1 12.5H-1C-1 19.9558 5.04416 26 12.5 26V24ZM24 12.5C24 18.8513 18.8513 24 12.5 24V26C19.9558 26 26 19.9558 26 12.5H24ZM12.5 1C18.8513 1 24 6.14873 24 12.5H26C26 5.04416 19.9558 -1 12.5 -1V1ZM12.5 -1C5.04416 -1 -1 5.04416 -1 12.5H1C1 6.14873 6.14873 1 12.5 1V-1Z",
    fill: "#E39C25"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bc3547b53611e557dc3b1547f1cd28f3.svg";
export { ForwardRef as ReactComponent };